import { createSelector, createSlice } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import { Breakpoint } from "admin/types/breakpoint";
import { RootState } from "admin/store";

const key = "breakpoint";

const initialState: Breakpoint = {
  isSetBreakpoint: false,
  breakpoint: "phone",
};

/** slice * */
export const breakpointSlice = createSlice({
  name: key,
  initialState,
  reducers: {
    setActiveBreakpoint: (state, action) => {
      state.breakpoint = action.payload;
      state.isSetBreakpoint = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state) => {
      // 常にクライアントの値を使用する
      return {
        ...state,
        // ...action.payload.breakpoint,
        isSetBreakpoint: state.isSetBreakpoint,
        breakpoint: state.breakpoint,
      };
    });
  },
});

/** selector **/
const stateSelector = (state: RootState) => state[key];

export const breakpointSelector = createSelector(
  stateSelector,
  (state) => state.breakpoint,
);

export const isSetBreakpointSelector = createSelector(
  stateSelector,
  (state) => state.isSetBreakpoint,
);

// action export
export const { setActiveBreakpoint } = breakpointSlice.actions;
